import { AccordionButton, AccordionItem } from '../../../Accordion'
import { ProgressBar } from '../../../ProgressBar'
import { QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE } from '../RequestProfileTabActivities.constants'
import {
  useAutoCollapseOnPhaseCompleted,
  useRequestProfileTabActivitiesPhaseActions,
} from '../RequestProfileTabActivities.hooks'
import { isRequestProfileTabActivitiesPhasePopulatable } from '../RequestProfileTabActivities.utils'
import { RequestProfileTabActivitiesAddActivityButton } from '../RequestProfileTabActivitiesAddActivityButton'
import { RequestProfileTabActivitiesPhaseHeader } from '../RequestProfileTabActivitiesPhaseHeader'
import { RequestProfileTabActivitiesPhaseTable } from '../RequestProfileTabActivitiesPhaseTable'

import * as styles from './RequestProfileTabActivitiesPhase.module.css'

function RequestProfileTabActivitiesPhase({
  canEditActivities,
  index,
  isOpen,
  permissions,
  phase,
  onOpen,
  onReloadPhase,
  onToggleOpen,
}) {
  const {
    handleAddActivity,
    handleGoToAttachedEmails,
    handleGoToAttachedFiles,
    handleStartPhase,
    handleToggleVisibility,
    isStartPhaseLoading,
  } = useRequestProfileTabActivitiesPhaseActions(phase)

  function handleClick() {
    onToggleOpen(phase.id)
  }

  function handleOpen() {
    onOpen(index)
  }

  useAutoCollapseOnPhaseCompleted({ isOpen, phase, onToggleOpen })

  const isExpandable = !isRequestProfileTabActivitiesPhasePopulatable(phase)
  const isContentOpen = isExpandable && isOpen

  return (
    <AccordionItem className={styles.RequestProfileTabActivitiesPhase}>
      <div className={styles.phaseHeaderRow}>
        {isExpandable ? (
          <AccordionButton
            disableActiveStyle
            hiddenArrowIcon
            className={styles.button}
            index={index}
            open={isOpen}
            qaName={QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_PHASE}
            variant='style2'
            onClick={handleClick}
            onOpen={handleOpen}
          />
        ) : null}
        <RequestProfileTabActivitiesPhaseHeader
          canEditActivities={canEditActivities}
          isOpen={isContentOpen}
          isStartPhaseLoading={isStartPhaseLoading}
          permissions={permissions}
          phase={phase}
          onAddActivity={handleAddActivity}
          onGoToAttachedEmails={handleGoToAttachedEmails}
          onGoToAttachedFiles={handleGoToAttachedFiles}
          onReloadPhase={onReloadPhase}
          onStartPhase={handleStartPhase}
          onToggleVisibility={handleToggleVisibility}
        />
      </div>
      <ProgressBar progress={phase.progress} />
      {isContentOpen ? (
        <div className={styles.content}>
          <RequestProfileTabActivitiesPhaseTable
            activities={phase.activities}
            canEditActivities={canEditActivities}
            permissions={permissions}
            phaseId={phase.id}
          />
          {permissions?.can_add_activity ? (
            <RequestProfileTabActivitiesAddActivityButton
              className={styles.addNewActivity}
              onClick={handleAddActivity}
            />
          ) : null}
        </div>
      ) : null}
    </AccordionItem>
  )
}

export default RequestProfileTabActivitiesPhase
